import { createContext } from 'react';
import type { ConsentCategory, ConsentSnapshot } from '@/services/consent';

export interface ConsentContextValue extends ConsentSnapshot {
  canUse(category: ConsentCategory): boolean;
  openPreferences(): void;
}

export const ConsentContext = createContext<ConsentContextValue | null>(null);

